import { FIELD_DEFAULT_LABEL, FIELD_REQUIRED_LABEL } from './fieldLayout.js';
import type { NumberField } from './workflows.types.js';

// Not Math.round: a spend gate steps in half percents, and rounding to whole
// ones made 0.5% show as 1%. toFixed also trims the float drift stepping leaves.
export function toPercent(value: number): number {
  return Number((value * 100).toFixed(2));
}

// The symbol comes from the field, resolved per account — a currency control
// cannot assume dollars.
export function withUnit(value: number, unit: string | null, currency = '$'): string {
  if (unit === 'percentage') return `${toPercent(value)}%`;
  if (unit === 'currency') return `${currency}${value}`;
  if (unit === 'days') return `${value} days`;
  return `${value}`;
}

export function formatNumber(field: NumberField, value: number | null): string {
  if (value === null) {
    if (field.placeholder !== null) return field.placeholder;
    return field.required ? FIELD_REQUIRED_LABEL : FIELD_DEFAULT_LABEL;
  }
  const body = withUnit(value, field.unit, field.currencySymbol ?? '$');
  return field.prefix === null ? body : `${field.prefix} ${body}`;
}

export function toDisplayNumber(field: NumberField, value: number): number {
  return field.unit === 'percentage' ? toPercent(value) : value;
}

export function fromDisplayNumber(field: NumberField, shown: number): number {
  return field.unit === 'percentage' ? shown / 100 : shown;
}
